/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkOperationDeviceStatusDto } from '../models/BulkOperationDeviceStatusDto';
import type { BulkOperationDto } from '../models/BulkOperationDto';
import type { BulkOperationStartFormDto } from '../models/BulkOperationStartFormDto';
import type { EntityModelResponseContainerBulkOperationCreateResult } from '../models/EntityModelResponseContainerBulkOperationCreateResult';
import type { EntityModelResponseContainerBulkOperationDto } from '../models/EntityModelResponseContainerBulkOperationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BulkOperationControllerService {
    /**
     * @returns BulkOperationDto OK
     * @throws ApiError
     */
    public static getOperation({
        operationId,
    }: {
        operationId: number,
    }): CancelablePromise<BulkOperationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/devices/bulkactions',
            query: {
                'operationId': operationId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerBulkOperationCreateResult OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: BulkOperationStartFormDto,
    }): CancelablePromise<EntityModelResponseContainerBulkOperationCreateResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/devices/bulkactions',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns BulkOperationDto OK
     * @throws ApiError
     */
    public static getCurrentOperation(): CancelablePromise<BulkOperationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/devices/bulkactions/current',
        });
    }
    /**
     * @returns BulkOperationDeviceStatusDto OK
     * @throws ApiError
     */
    public static getOperationErrors({
        operationId,
    }: {
        operationId: number,
    }): CancelablePromise<Array<BulkOperationDeviceStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/devices/bulkactions/errors',
            query: {
                'operationId': operationId,
            },
        });
    }
    /**
     * @returns BulkOperationDto OK
     * @throws ApiError
     */
    public static getLatestOperation(): CancelablePromise<BulkOperationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/devices/bulkactions/latest',
        });
    }
    /**
     * @returns BulkOperationDto OK
     * @throws ApiError
     */
    public static stopBulkOperation(): CancelablePromise<BulkOperationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/devices/bulkactions/stop',
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static warmup(): CancelablePromise<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 EARLY_HINTS' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 CONTENT_TOO_LARGE' | '413 PAYLOAD_TOO_LARGE' | '414 URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '421 MISDIRECTED_REQUEST' | '422 UNPROCESSABLE_CONTENT' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/devices/bulkactions/warmup',
        });
    }
    /**
     * @returns EntityModelResponseContainerBulkOperationDto OK
     * @throws ApiError
     */
    public static updateBulkOperation({
        bulkOperationId,
        requestBody,
    }: {
        bulkOperationId: number,
        requestBody: BulkOperationDto,
    }): CancelablePromise<EntityModelResponseContainerBulkOperationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/devices/bulkactions/{bulkOperationId}',
            path: {
                'bulkOperationId': bulkOperationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
